export const SITE = {
  name: "ForbesOS Websites",
  tagline: "Professional Website Design & Development",
  phone: "0477 055 298",
  phoneHref: "tel:0477055298",
  abn: "61 352 710 597",
  email: "tylerjoelclarke@gmail.com",
  emailHref: "mailto:tylerjoelclarke@gmail.com",
  pricing: { care: 30, domain: 20, currency: "AUD", gst: "GST inclusive" },
  deposit: 150,
  timeline: "1–3 weeks",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "Website Care", id: "website-care" },
  { label: "Portfolio", id: "portfolio" },
  { label: "Process", id: "process" },
  { label: "About", id: "about" },
  { label: "Contact", id: "contact" },
];
